import React, { Fragment } from 'react';

import { NavLink } from 'react-router-dom';
import classes from './Drawer.module.css';

const DrawerRindegastos = () => {
	return (
		<Fragment>
			<nav className={classes.nav}>
				{/* Menu User Hook */}
				<div className={classes.userMenuHeader}>
					<label className={classes.userMenuHeader}>
						<span className={classes.userMenuAvatar}>
							<i>
								<svg height="50" width="50" viewBox="0 0 50 50">
									<g fill="#9BA9BB">
										<path></path>
									</g>
								</svg>
							</i>
						</span>
						<p className={classes.userMenuName}> {sessionStorage.getItem('username')} </p>
						<span></span>
					</label>
				</div>
				{/* Menu< and Submenu Component */}
				<div className={classes.navigation}>
					<div className={classes.section}>
						<p className={classes.sectionTitle}>Menú 1</p>
						<NavLink activeClassName={classes.sectionLinkActive} className={classes.sectionLink} to="/unitEconomics">
							<span className={classes.sectionLinkText}>Unit Economics</span>
						</NavLink>
						<NavLink activeClassName={classes.sectionLinkActive} className={classes.sectionLink} to="/nps">
							<span className={classes.sectionLinkText}>NPS</span>
						</NavLink>
					</div>
					{/* Cierra el menu 1 */}
					<div className={classes.section}>
						<p className={classes.sectionTitle}>Menú 2</p>
						<NavLink activeClassName={classes.sectionLinkActive} className={classes.sectionLink} to="/core">
							<span className={classes.sectionLinkText}>Core Negocio</span>
						</NavLink>
						<NavLink activeClassName={classes.sectionLinkActive} className={classes.sectionLink} to="/funnel">
							<span className={classes.sectionLinkText}>Funnel</span>
						</NavLink>
						<NavLink activeClassName={classes.sectionLinkActive} className={classes.sectionLink} to="/finanzas">
							<span className={classes.sectionLinkText}>Finanzas</span>
						</NavLink>
						<NavLink activeClassName={classes.sectionLinkActive} className={classes.sectionLink} to="/ventas">
							<span className={classes.sectionLinkText}>Ventas</span>
						</NavLink>
						<NavLink activeClassName={classes.sectionLinkActive} className={classes.sectionLink} to="/scanit">
							<span className={classes.sectionLinkText}>Scanit</span>
						</NavLink>
					</div>
				</div>
			</nav>
		</Fragment>
	);
};

export default React.memo(DrawerRindegastos);
